<template>
    <div class="fhv-centent" v-loading="loading" >
        <h4 class="title-topic">Storage Service - FTP Service Setup</h4>
        <p>Note: To enable Samba Server, at least one samba user account would be set, and also need a storage device. To add a samba user, please entry the page "Storage User Accounts".</p>



        <el-form :model="From" 
            ref="From" 
            label-width="180px" 
            label-position="left"
            class="fhv-form" 
            size="small"
            :disabled="$G_DEVICE_CFG.isReadOnly"
            >
            <el-form-item label="Enable FTP Service:"  >
                 <el-switch v-model="flag"  @change="changes" ></el-switch>
            </el-form-item>
            <div  v-if="flag">

            
             <el-form-item label="Username :" prop="port" >
                 <el-input v-model="From.name"></el-input>
            </el-form-item>

            <el-form-item label="Password :" prop="mirror">
                <el-input v-model="From.pass" type="password"></el-input>
            </el-form-item>

             <el-form-item label="Port :" prop="mirror">
                <el-input v-model="From.port"></el-input>
            </el-form-item>
            </div>
            <el-form-item>
                <el-button type="primary" @click="save">Apply</el-button>
            </el-form-item>
        </el-form>

    </div>
</template>

<script>
export default {
  data() {
    return {
      flag: false,
      loading: false,
      isFountUsb: false,
      From: {
        name: "",
        pass: "",
        port: ""
      }
    };
  },
  methods: {
    ajaxrequesthttp() {
      let postdata = {
        CmdType: "GET_FTP"
      };
      this.loading = true;
      axios.post("/boafrm/formftp", postdata).then(res => {
        this.loading = false;
        let data = res.data;
        if (data == "undefined" || data == "" || data.ret == "-1") {
          this.$message.error("Data acquisition failure!");
          return;
        }
        this.isFountUsb = data.isFountUsb;
        if (data.ftpSwitch == 1) {
          this.flag = true;
        } else {
          this.flag = false;
        }
        this.From.name = data.ftpName;
        this.From.pass = data.ftpPassword;
        this.From.port = data.ftpPort;
      });
    },
    changes() {
      if (this.flag == true) {
        if (!this.isFountUsb) {
          this.flag = false;
          this.$message.error("Did not find USB device, can not open!");
          return;
        }
      }
    },
    save() {
      if (this.flag == false) {
        var ftpSwitch = 0;
      } else {
        var ftpSwitch = 1;
      }
      let postdata = {
        CmdType: "SET_FTP",
        ftpSwitch: ftpSwitch,
        ftpName: this.From.name,
        ftpPassword: this.From.pass,
        ftpPort: this.From.port
      };
      if (!validator.isPort(postdata.ftpPort)) {
        this.$message.error("Please enter the correct port number!");
        return;
      }
      this.loading = true;
      axios.post("/boafrm/formftp", postdata).then(res => {
        this.loading = false;
        let data = res.data;
        if (data.ret == "0") {
          this.$message.success("Configured successfully!");
        } else {
          this.$message.error("Configuration failed!");
        }
      });
    }
  },
  created() {
    this.ajaxrequesthttp();
  }
};
</script>




